

import Vue from 'vue'
export default Vue.extend({
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    isFocus: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    }
  },
  beforeCreate() {
    // @ts-ignore
    this.$fontTransform.run(this.$i18n.vm.messages)
  },
  render() {
    return (
      <div
        class={[
          'placeholder',
          (this.isFocus || this.value !== '') && 'is-focus'
        ]}
        style={this.$t('pingFangHK400.style')}
      >
        {this.placeholder}
      </div>
    )
  }
})
